/**
 * Registers the static navigation commands with the palette.
 * Must render inside both a Router (for `useNavigate`) and the
 * `<CommandPaletteProvider>` (for `useRegisterCommands`).
 */

import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRegisterCommands } from '@/lib/commandPalette/registry';
import { createNavigationActions } from '@/lib/commandPalette/seedActions';

export function NavigationCommandSeed() {
  const navigate = useNavigate();
  const actions = useMemo(() => createNavigationActions(navigate), [navigate]);
  useRegisterCommands(actions);
  return null;
}
